<template>
    <div class="p-4 flex rounded-3xl backdrop-blur-lg bg-gray-900 w-[232px]">
        <div class="w-full">
            <ul class="space-y-2 w-full">
                <template v-for="(megaMenuItem, megaMenuIndex) in item.subMenu">
                    <li class="w-full">
                        <NuxtLinkLocale :to="megaMenuItem.link" class="block w-full p-2 text-gray-400 font-bold">
                            {{ megaMenuItem.title }}
                        </NuxtLinkLocale>

                        <template v-for="subItem in megaMenuItem.subMenu">
                            <div
                                @click="handleLinkClick(subItem)"
                                class="text-body-md w-full p-2 block rounded-lg text-brand-300 transition-all hover:bg-brand-transparent-10 font-medium cursor-pointer"
                            >
                                {{ subItem.title }}
                            </div>
                        </template>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IHeaderLinkItem } from "~/types/components/header.type";

interface IProps {
    item: IHeaderLinkItem;
}
const emit = defineEmits(["click:item"]);
defineProps<IProps>();
const localePath = useLocalePath();

const handleLinkClick = async (item: IHeaderLinkItem) => {
    await navigateTo(localePath(item.link as string));

    setTimeout(() => {
        const el = document.querySelector(item.elementId as string);
        el?.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
    }, 1000);
};
</script>
